import { render, staticRenderFns } from "./ShareSVG.vue?vue&type=template&id=d6d17a88&"
import script from "./ShareSVG.vue?vue&type=script&lang=js&"
export * from "./ShareSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports